"use client"

import { Header } from "@/components/header"
import { Footer } from "@/components/footer"
import { Calendar, Download } from "lucide-react"
import { useState, useEffect } from "react"
import { RevealOnScroll } from "@/components/reveal-on-scroll"

interface Holiday {
    id: number
    date: string
    title: string
    description: string
    type: "holiday" | "event" | "exam"
}

export default function YearlyPlannerPage() {
    const [holidays, setHolidays] = useState<Holiday[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        // Academic Year 2025-2026 Holiday List
        const mockData: Holiday[] = [
            // June 2025
            { id: 1, date: "2025-06-16", title: "Yoga Day", description: "Monday", type: "holiday" },
            { id: 2, date: "2025-06-21", title: "Muharram", description: "Saturday", type: "holiday" },
            { id: 3, date: "2025-06-06", title: "Management Day", description: "Saturday", type: "holiday" },
            // July 2025
            { id: 4, date: "2025-07-28", title: "I UNIT TEST", description: "28th July - 1st August", type: "exam" },
            // August 2025
            { id: 5, date: "2025-08-02", title: "Raksha Bandhan", description: "Saturday", type: "holiday" },
            { id: 6, date: "2025-08-09", title: "Independence Day / Pateti (Parsi New year)", description: "Friday", type: "event" },
            { id: 7, date: "2025-08-15", title: "Independence Day", description: "Friday", type: "event" },
            { id: 8, date: "2025-08-16", title: "Open House", description: "Saturday", type: "event" },
            { id: 9, date: "2025-08-20", title: "Ganesh Chaturthi", description: "Wednesday", type: "holiday" },
            // September 2025
            { id: 10, date: "2025-09-05", title: "Teacher's Day / Id-E-Milad", description: "Friday", type: "event" },
            { id: 11, date: "2025-09-08", title: "Feast Day of Mother Mary", description: "Monday", type: "holiday" },
            { id: 12, date: "2025-09-30", title: "School Feast", description: "Tuesday", type: "event" },
            // October 2025
            { id: 13, date: "2025-10-02", title: "Mahatma Gandhi Jayanti / Dussehra", description: "Thursday", type: "holiday" },
            { id: 14, date: "2025-10-06", title: "I SEMESTER EXAM", description: "6th October to 17th October", type: "exam" },
            { id: 15, date: "2025-10-18", title: "Diwali Vacation", description: "18th October to 30th October", type: "holiday" },
            { id: 16, date: "2025-10-31", title: "II Term", description: "31st October to 1st May, 2026", type: "event" },
            // November 2025
            { id: 17, date: "2025-11-05", title: "Guru Nanak Jayanti", description: "Wednesday", type: "holiday" },
            { id: 18, date: "2025-11-08", title: "Open House", description: "Saturday", type: "event" },
            { id: 19, date: "2025-11-26", title: "Constitutional Day", description: "Wednesday", type: "holiday" },
            { id: 20, date: "2025-11-28", title: "Sports Meet", description: "Friday", type: "event" },
            // December 2025
            { id: 21, date: "2025-12-09", title: "I Prelims (X)", description: "9th December to 19th December", type: "exam" },
            { id: 22, date: "2025-12-10", title: "International Human Rights Day", description: "Wednesday", type: "event" },
            { id: 23, date: "2025-12-12", title: "Exhibition: Pre-primary & Primary", description: "Friday", type: "event" },
            { id: 24, date: "2025-12-23", title: "Christmas Vacation", description: "23rd December 2025 - 1st January 2026", type: "holiday" },
            // January 2026
            { id: 25, date: "2026-01-02", title: "RE-OPENING", description: "Friday", type: "event" },
            { id: 26, date: "2026-01-02", title: "I Prelims Result (X)", description: "Friday", type: "event" },
            { id: 27, date: "2026-01-08", title: "II Unit Test / II Prelims (X)", description: "8th January to 21st January", type: "exam" },
            { id: 28, date: "2026-01-14", title: "Makar Sankranti", description: "Wednesday", type: "holiday" },
            { id: 29, date: "2026-01-26", title: "Republic Day", description: "Monday", type: "holiday" },
            // February 2026
            { id: 30, date: "2026-02-07", title: "Open House", description: "Saturday", type: "event" },
            { id: 31, date: "2026-02-14", title: "Mahashivratri", description: "Sunday", type: "holiday" },
            { id: 32, date: "2026-02-19", title: "Shiv Jayanti", description: "Thursday", type: "holiday" },
            // March 2026
            { id: 33, date: "2026-03-04", title: "Holi", description: "Wednesday", type: "holiday" },
            { id: 34, date: "2026-03-19", title: "Gudi Padwa", description: "Thursday", type: "holiday" },
            { id: 35, date: "2026-03-21", title: "Ramzan Eid", description: "Saturday", type: "holiday" },
            { id: 36, date: "2026-03-25", title: "II SEMESTER EXAM", description: "25th March to 10th April 2026", type: "exam" },
            { id: 37, date: "2026-03-26", title: "Ram Navmi", description: "Friday", type: "holiday" },
            { id: 38, date: "2026-03-31", title: "Mahavir Jayanti", description: "Tuesday", type: "holiday" },
            // April 2026
            { id: 39, date: "2026-04-03", title: "Good Friday", description: "Friday", type: "holiday" },
            { id: 40, date: "2026-04-14", title: "Dr. Ambedkar Jayanti", description: "Tuesday", type: "holiday" },
            { id: 41, date: "2026-04-30", title: "Annual Result", description: "Thursday", type: "event" },
            // May 2026
            { id: 42, date: "2026-05-01", title: "Maharashtra Day / Bauddha Pournima", description: "Friday", type: "holiday" },
            { id: 43, date: "2026-05-02", title: "Summer Vacation", description: "2nd May to 9th June, 2026", type: "holiday" }
        ]

        setTimeout(() => {
            setHolidays(mockData)
            setLoading(false)
        }, 500)
    }, [])

    const getTypeColor = (type: string) => {
        switch (type) {
            case "holiday":
                return "bg-red-100 text-red-800 border-red-200"
            case "event":
                return "bg-blue-100 text-blue-800 border-blue-200"
            case "exam":
                return "bg-orange-100 text-orange-800 border-orange-200"
            default:
                return "bg-gray-100 text-gray-800 border-gray-200"
        }
    }

    const formatDate = (dateString: string) => {
        const date = new Date(dateString)
        return date.toLocaleDateString("en-IN", {
            day: "numeric",
            month: "long",
            year: "numeric"
        })
    }

    const getMonthName = (dateString: string) => {
        const date = new Date(dateString)
        return date.toLocaleDateString("en-IN", { month: "long", year: "numeric" })
    }

    // Group holidays by month
    const groupedHolidays = holidays.reduce((acc, holiday) => {
        const month = getMonthName(holiday.date)
        if (!acc[month]) {
            acc[month] = []
        }
        acc[month].push(holiday)
        return acc
    }, {} as Record<string, Holiday[]>)

    return (
        <main className="min-h-screen bg-white">
            <Header />

            {/* Hero Section */}
            <RevealOnScroll animationClass="animate-fade-in">
                <section className="relative bg-gradient-to-br from-[#113545] to-[#6b1515] text-white py-16 sm:py-20 lg:py-24">
                    <div className="absolute inset-0 bg-black/10"></div>
                    <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="max-w-4xl mx-auto text-center">
                            <span className="inline-block px-4 sm:px-6 py-2 sm:py-3 bg-white/20 backdrop-blur-sm text-white rounded-full text-xs sm:text-sm font-semibold mb-4 border border-white/30">
                                Academic Calendar
                            </span>
                            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-4 sm:mb-6">
                                Yearly Planner & Holiday List
                            </h1>
                            <p className="text-lg sm:text-xl text-white/90 max-w-2xl mx-auto">
                                Plan ahead with our comprehensive academic calendar featuring holidays, events, and important dates for the academic year
                            </p>
                        </div>
                    </div>
                </section>
            </RevealOnScroll>

            {/* Download Section */}
            <RevealOnScroll animationClass="animate-slide-in-up">
                <section className="py-8 bg-gray-50 border-b">
                    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 max-w-6xl mx-auto">
                            <div className="flex items-center gap-3">
                                <Calendar className="h-6 w-6 text-[#113545]" />
                                <div>
                                    <h3 className="font-semibold text-gray-900">Academic Year 2025-26</h3>
                                    <p className="text-sm text-gray-600">Tentative Yearly Programme - Primary / Secondary Section</p>
                                </div>
                            </div>
                            <a
                                href="/images/Academic-Year-2025-26.pdf"
                                download="Academic-Year-2025-26.pdf"
                                className="flex items-center gap-2 px-6 py-3 bg-[#113545] text-white rounded-lg hover:bg-[#6b1515] transition-all shadow-md hover:shadow-lg"
                            >
                                <Download className="h-5 w-5" />
                                <span className="font-semibold">Download PDF</span>
                            </a>
                        </div>
                    </div>
                </section>
            </RevealOnScroll>

            {/* Calendar Content */}
            <section className="py-12 sm:py-16 lg:py-20">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="max-w-6xl mx-auto">
                        {loading ? (
                            <div className="flex justify-center items-center py-12">
                                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#113545]"></div>
                            </div>
                        ) : (
                            <div className="space-y-12">
                                {Object.entries(groupedHolidays).map(([month, monthHolidays], index) => (
                                    <RevealOnScroll key={month} animationClass="animate-slide-in-up">
                                        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
                                            <div className="bg-gradient-to-r from-[#113545] to-[#6b1515] px-6 py-4">
                                                <h2 className="text-2xl font-serif font-bold text-white">{month}</h2>
                                            </div>
                                            <div className="p-6">
                                                <div className="space-y-4">
                                                    {monthHolidays.map((holiday) => (
                                                        <div
                                                            key={holiday.id}
                                                            className="flex flex-col sm:flex-row sm:items-center gap-4 p-4 rounded-lg border-2 hover:shadow-md transition-all"
                                                        >
                                                            <div className="flex-shrink-0">
                                                                <div className="bg-[#113545] text-white rounded-lg p-4 text-center min-w-[80px]">
                                                                    <div className="text-3xl font-bold">
                                                                        {new Date(holiday.date).getDate()}
                                                                    </div>
                                                                    <div className="text-xs uppercase tracking-wide">
                                                                        {new Date(holiday.date).toLocaleDateString("en-IN", { weekday: "short" })}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="flex-1">
                                                                <h3 className="text-lg font-bold text-gray-900 mb-1">{holiday.title}</h3>
                                                                <p className="text-gray-600 text-sm">{holiday.description}</p>
                                                            </div>
                                                            <div className="flex-shrink-0">
                                                                <span className={`inline-block px-4 py-2 rounded-full text-xs font-semibold border ${getTypeColor(holiday.type)}`}>
                                                                    {holiday.type.charAt(0).toUpperCase() + holiday.type.slice(1)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </RevealOnScroll>
                                ))}
                            </div>
                        )}

                        {/* Legend */}
                        <RevealOnScroll animationClass="animate-fade-in">
                            <div className="mt-12 bg-gray-50 rounded-xl p-6 border border-gray-200">
                                <h3 className="text-lg font-bold text-gray-900 mb-4">Legend</h3>
                                <div className="flex flex-wrap gap-4">
                                    <div className="flex items-center gap-2">
                                        <span className="inline-block w-4 h-4 rounded-full bg-red-500"></span>
                                        <span className="text-sm text-gray-700">Holiday</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <span className="inline-block w-4 h-4 rounded-full bg-blue-500"></span>
                                        <span className="text-sm text-gray-700">School Event</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <span className="inline-block w-4 h-4 rounded-full bg-orange-500"></span>
                                        <span className="text-sm text-gray-700">Examination</span>
                                    </div>
                                </div>
                            </div>
                        </RevealOnScroll>

                        {/* Important Notes */}
                        <RevealOnScroll animationClass="animate-fade-in">
                            <div className="mt-8 bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                                <h3 className="text-lg font-bold text-blue-900 mb-3">Important Notes</h3>
                                <ul className="space-y-2 text-sm text-blue-800">
                                    <li className="flex items-start gap-2">
                                        <span className="text-blue-500 mt-1">•</span>
                                        <span>The school reserves the right to declare additional holidays or modify the calendar as per government directives.</span>
                                    </li>
                                    <li className="flex items-start gap-2">
                                        <span className="text-blue-500 mt-1">•</span>
                                        <span>Parents will be notified in advance about any changes to the academic calendar.</span>
                                    </li>
                                    <li className="flex items-start gap-2">
                                        <span className="text-blue-500 mt-1">•</span>
                                        <span>Festival holidays may vary based on lunar calendar and official announcements.</span>
                                    </li>
                                    <li className="flex items-start gap-2">
                                        <span className="text-blue-500 mt-1">•</span>
                                        <span>Examination dates and schedules will be communicated separately through the student portal.</span>
                                    </li>
                                </ul>
                            </div>
                        </RevealOnScroll>
                    </div>
                </div>
            </section>

            <Footer />
        </main>
    )
}
